<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-textarea v-model="remark"></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closePlannerRemark">close</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";


export default {
  name: "PlannerRemark",
  computed: {
    ...mapGetters(["activeAddress"])
  },
  data() {
    return {
      remark: "",
    };
  },
  methods: {
    ...mapActions(["savePlannerRemark"]),
    closePlannerRemark() {
      this.savePlannerRemark(this.remark);
      this.$parent.closePlannerRemark();
    }
  },
  created() {
    this.remark = this.activeAddress.remarkPlanner;
  }
}
</script>
